var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"width":_vm.width,"height":_vm.height || null,"center":"","visible":_vm.DialogVisible,"title":_vm.title || '',"close-on-click-modal":false,"append-to-body":true},on:{"update:visible":function($event){_vm.DialogVisible=$event}}},[(_vm.DialogVisible)?[_vm._t("default")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }